itsoftApp.createModule("virusesAnimation", function () {
    var viruses = document.querySelectorAll(".page__virus, .js-virus");

    Array.prototype.forEach.call(viruses, function (virus) {
        virus.addEventListener("mouseenter", function (evt) {
            if (evt.target.classList.contains("js-leave")) {
                evt.target.classList.remove("js-leave");
            }
            evt.target.classList.add("js-hover");
        });

        virus.addEventListener("mouseleave", function (evt) {
            evt.target.classList.add("js-leave");
            evt.target.classList.remove("js-hover");
        });
    });
});